import axios from 'axios'
import router from '@router'
import store from '@store'
import {msgError, openLoading, closeLoading} from '@utils/element'

// 清除IE浏览器请求的缓存
axios.defaults.headers.get['Pragma'] = 'no-cache';
axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store';

// 创建axios实例对象
const instance = axios.create({
  // 开发时使用代理
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时时间
  timeout: 10 * 60 * 1000
});

// 开启加载的URL列表
const loadingRequestList = [];

// 判断是否开启加载
function dealLoading(data, id) {
  if (data.VUE_CLOSE_LOADING) {
    delete data.VUE_CLOSE_LOADING
  } else if (data instanceof FormData && data.get && data.get("VUE_CLOSE_LOADING")) {
    data.delete && data.delete("VUE_CLOSE_LOADING")
  } else {
    loadingRequestList.push(id);
    openLoading();
  }
}

function deleteLoading(id) {
  // 删除加载
  let index = loadingRequestList.indexOf(id);
  if (index !== -1) {
    loadingRequestList.splice(index, 1);
    !loadingRequestList.length && closeLoading();
  }
  // 删除请求
  const requestList = store.state.requestList || [];
  index = requestList.findIndex(item => item.id === id);
  if (index !== -1) {
    requestList.splice(index, 1);
    store.commit("setRequestList", requestList);
  }
}

async function dealResponseBlob (blob, response) {
  const resultData = {}
  const contentType = response.headers["content-type"]
  if (contentType.indexOf("json") !== -1) {
    const reader = new FileReader()
    reader.readAsText(blob)
    const result = await new Promise((resolve) => {
      reader.onload = (event) => {
        const result = event?.target?.result || ""
        resolve(result)
      }
    })
    resultData.json = JSON.parse(result)
  } else {
    resultData.isBlob = true
    const disposition = response.headers["content-disposition"];
    disposition && (blob.name = disposition.match(/filename="(.*)"/i)?.[1] || "");
  }
  return resultData
}

const CancelToken = axios.CancelToken;
// 添加请求拦截器
instance.interceptors.request.use(
  // 请求成功时
  function (request) {
    //添加请求(取消请求时使用)
    const requestList = store.state.requestList || [];
    const requestId = Date.now() + Math.random().toString(36).substr(2, 9);
    request.requestId = requestId;
    request.cancelToken = new CancelToken(source => requestList.push({api: request.apiKey, id: requestId, source}));
    store.commit("setRequestList", requestList);
    // 判断是否开启加载
    request.data && dealLoading(request.data, requestId);
    request.params && dealLoading(request.params, requestId);
    const {uid, token} = store.state;
    //添加uid
    uid && (request.headers['X-Wys-Uid'] = uid);
    //添加token
    token && (request.headers['Authorization'] = token);
    return request
  },
  // 请求失败时
  function (error) {
    const id = error?.config?.requestId || error.message;
    deleteLoading(id);
    if (!axios.isCancel(error)) {
      msgError('请求失败！');
      console.log(error);
    }
  }
);

// 添加响应拦截器
instance.interceptors.response.use(
  // 响应成功时
  async function (response) {
    const id = response.config.requestId;
    deleteLoading(id);
    let res = response.data;
    if (response.config.responseType === "blob") {
      const result = await dealResponseBlob(res, response);
      if (result.isBlob) return res;
      res = result.json;
    }
    if (res.code === 0 || typeof res === "string") {
      return res;
    } else if ([10021,20003].includes(res.code)) {
      router.push('/login').catch(() => {});
      msgError(res.msg);
    } else {
      let msg = res.msg || '';
      if (response.config.url === "adm/v3/login") {
        if (res?.data?.verify) {
          msgError(msg);
          return {showVerify: true};
        }
      } else if (res.data) {
        msg += '，';
        if (res.data.detail) {
          msg += res.data.detail
        } else if (res.data.msg) {
          msg += res.data.msg
        } else {
          msg += res.data
        }
      }
      msgError(msg);
    }
  },
  // 响应失败时
  function (error) {
    const id = error?.config?.requestId || error.message;
    deleteLoading(id);
    if (!axios.isCancel(error)) {
      msgError('响应失败！');
      console.log(error);
    }
  }
);

export default instance;
